export default {"src":"/_next/static/media/value-pro.5b0c49d0.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};